(function () {
  const SUBSCRIPTION_ANCHOR_SELECTOR = "#subscription-options";
  const ATC_WRAPPER_SELECTOR = ".product-single__add-to-cart";

  function moveSubscriptionAboveATC() {
    const subscriptionAnchor = document.querySelector(SUBSCRIPTION_ANCHOR_SELECTOR);
    if (!subscriptionAnchor) return false;

    const atcWrapper = document.querySelector(ATC_WRAPPER_SELECTOR);
    if (!atcWrapper) return false;

    // Find the outer container that includes "Purchase Options:"
    const subscriptionSection =
      subscriptionAnchor.closest("div")?.parentElement?.closest("div") ||
      subscriptionAnchor.closest("div");

    if (!subscriptionSection) return false;

    // Guard: don’t move repeatedly
    if (subscriptionSection.dataset.movedAboveAtc === "1") return true;

    // Preserve current scroll position (prevents jump-to-middle)
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    // Move the section above the ATC wrapper
    atcWrapper.parentNode.insertBefore(subscriptionSection, atcWrapper);

    // ✅ Your padding (kept)
    subscriptionSection.style.paddingBottom = "10px";

    // Mark as moved + optional styling hook
    subscriptionSection.dataset.movedAboveAtc = "1";
    subscriptionSection.classList.add("moved-subscription-above-atc");

    // Restore scroll position after DOM reflow
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
    });

    return true;
  }

  function runWithObserver() {
    // Try immediately
    if (moveSubscriptionAboveATC()) return;

    // Observe briefly for app-injected DOM, then stop
    let attempts = 0;
    const maxAttempts = 25;

    const observer = new MutationObserver(() => {
      attempts += 1;
      if (moveSubscriptionAboveATC() || attempts >= maxAttempts) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runWithObserver);
  } else {
    runWithObserver();
  }
})();
